export const PRICE_MATCH = 'PRICE_MATCH';
export const ATOL = 'ATOL';
export const ABTA = 'ABTA';
export const WHAT_IS_THIS_PRICE = 'WHAT_IS_THIS_PRICE';
export const ZERO_PERCENT = 'ZERO_PERCENT';
export const DEPOSIT_FROM = 'DEPOSIT_FROM';
export const PHONE_OPENING_TIME = 'PHONE_OPENING_TIME';
export const TERMS_CONDITIONS_AGENCY = 'TERMS_CONDITIONS_AGENCY';
export const TERMS_CONDITIONS_SUPPLIER = 'TERMS_CONDITIONS_SUPPLIER';
export const FACILITIES_LIST = 'FACILITIES_LIST';
export const FACILITIES_OVERVIEW = 'FACILITIES_OVERVIEW';
export const FACILITIES_OVERVIEW_GALLERY = 'FACILITIES_OVERVIEW_GALLERY';
export const PRICE_TRACKER = 'PRICE_TRACKER';
export const HAND_LUGGAGE = 'HAND_LUGGAGE';
export const TRANSFER_REMINDER = 'TRANSFER_REMINDER';
export const ASSISTED_BOOKING_STATUS = 'ASSISTED_BOOKING_STATUS';
export const FREE_HOTEL_AMENDS = 'FREE_HOTEL_AMENDS';
export const CHECK_DUPLICATE_NAMES = 'CHECK_DUPLICATE_NAMES';
export const EMAIL_DEAL = 'EMAIL_DEAL';
export const AIRLINE_PASSENGER_LIST = 'AIRLINE_PASSENGER_LIST';
export const AIRLINE_SEAT_LIST = 'AIRLINE_SEAT_LIST';
export const ROOM_OPTIONS = 'ROOM_OPTIONS';
export const CAR_HIRE_OPTIONS = 'CAR_HIRE_OPTIONS';
export const CAR_TERMS_AND_CONDITIONS = 'CAR_TERMS_AND_CONDITIONS';



/** WEBPACK FOOTER **
 ** ./src/constants/modal.js
 **/